import { Record } from "../../.fable/fable-library.3.2.6/Types.js";
import { record_type, string_type, class_type } from "../../.fable/fable-library.3.2.6/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../.fable/Fable.React.7.4.1/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { uncurry } from "../../.fable/fable-library.3.2.6/Util.js";

export class Props extends Record {
    constructor(text, htmlFor) {
        super();
        this.text = text;
        this.htmlFor = htmlFor;
    }
}

export function Props$reflection() {
    return record_type("Loop54.Portal.WebUI.Components.Label.Props", [], Props, () => [["text", class_type("Fable.React.ReactElement")], ["htmlFor", string_type]]);
}

export const Label = FunctionComponent_Of_Z5A158BBF((props) => react.createElement("label", {
    htmlFor: props.htmlFor,
}, props.text), void 0, uncurry(2, void 0), void 0, "Label", "/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/Components/Label/Label.fs", 12);

